'use strict';

const config = {
    submitEvent: 'click',
    triggerTarget: '.js-remove-from-basket',
    basketCount: '.js-basket-count',
    basket: '.js-basket',
    exportButton: '.js-export-basket',
    fadeOutTime: 500 // this must match the transition time in basket-listing.less
};

class RemoveFromBasket {

    constructor() {
        this.setupClickEvents();
    }

    /**
     * Sets up all events for remove from basket component.
     */
    setupClickEvents() {

        $(config.triggerTarget).each( function () {
            $(this).on(config.submitEvent, function (e) {
                e.preventDefault();
                const $this = $(this);
                const ajaxUrl = $this.attr('href');
                const stockNumber = [];
                const message = $this.data('message');
                stockNumber.push($this.data('stocknumber'));
                let confirmation = confirm(message);
                if (confirmation) {
                    $.ajax({
                        url: ajaxUrl,
                        data: {stockNumber: stockNumber},
                        success: function (result, textStatus, request) {
                            // remove basket listing element
                            let listing = $("*[data-stocknumber='" + stockNumber + "']");
                            $(listing).css({'opacity': 0});
                            setTimeout(function() {
                                $(listing).remove();
                            }, config.fadeOutTime);

                            // update export url and basket header count
                            const newBasketCount = request.getResponseHeader('X-Item-Count');

                            // fire event for new Styleguide
                            let event = document.createEvent('Event');
                            event.initEvent('basketTotalUpdated', true, true);
                            event.itemCount = newBasketCount;

                            window.dispatchEvent(event)

                            $(config.basketCount).text(newBasketCount);
                            $(config.exportButton).attr('href', request.getResponseHeader('X-Export-Url'));

                            // refresh the page if basket is empty
                            if (newBasketCount === '0') {
                                document.location.reload();
                            }
                        }
                    });
                }
            });
        });
    }
}

$(window).load(function(){
    new RemoveFromBasket();
});



// WEBPACK FOOTER //
// ./src/js/components/remove-from-basket.js